import { render, staticRenderFns } from "./ProductChooser.vue?vue&type=template&id=ab28bd6c&"
import script from "./ProductChooser.vue?vue&type=script&lang=js&"
export * from "./ProductChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports